import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_get_allocation_strategy_workflowsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { is_active?: boolean, name?: string, lookup?: string }): 
  Promise<{ result: { Id?: string, Description?: string, IsActive?: boolean, LookupCode?: string, Name?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_allocation_strategy_workflows/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { is_active?: boolean, name?: string, lookup?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: string, Description?: string, IsActive?: boolean, LookupCode?: string, Name?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_allocation_strategy_workflows/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { is_active?: boolean, name?: string, lookup?: string, $keys: string[] }): 
  Promise<{ result: { Id?: string, Description?: string, IsActive?: boolean, LookupCode?: string, Name?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_allocation_strategy_workflows/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      is_active?: boolean, name?: string, lookup?: string    }) {
      return false;
    }
}
